import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Nav/Navbar";
import Footer from "../components/Footer/Footer";
import Button from "../components/Button/Button";
import './book.css';


const lecture_2_4 = () => {
    return (
        <div>
              <Helmet>
        <meta charSet="utf-8" />
        <title>Тема 2.4. Модернизация и конфигурирование ЭВМ с учетом решаемых задач</title>
      </Helmet>
            <Navbar />
            <div className="main">
                <div className="main_item">
                <h2 className="h2_main">Раздел 2. Текущее техническое обслуживание сети</h2>
                    <h3 className="h3_main">Тема 2.4. Модернизация и конфигурирование ЭВМ с учетом решаемых задач</h3>
                    <Button link_left="/book/lecture_2_3" link_rigth="/book/questions_2" />
                    <div className="charter_book">
                    Темпы развития компьютерных технологий растут с каждым
годом, опережая самые оптимистические прогнозы, поэтому
любые экономические оценки в этой области на период 3-5 лет
неизбежно будут неточными. Вместе с тем при сохранении существующих тенденций эта неточность лежит в области скорее недооценки, чем переоценки грядущих технологических
скачков и связанных с ними стоимостных показателей.<br></br>
Сегодня полная смена поколений компьютерной техники
происходит примерно за трехлетний период, а смена модельных рядов ведущих фирм — вообще один-два раза в год.
При этом системные блоки нового поколения создаются на
основе принципиально иных конструктивных и технологических решений, что приводит к практически полной их несовместимости по элементной базе с системными блоками
предыдущего поколения (за счет изменения материнских
плат, геометрических размеров блоков и посадочных мест,
появления новых типов разъемов и т.п.).<br></br>
Практически одновременно с появлением компьютеров
нового поколения комплектующие для устаревшей техники
снимаются с производства. Это приводит к тому, что уже после трех лет эксплуатации компьютера его ремонт путем замены неисправных блоков экономически нецелесообразен
ввиду чрезмерной стоимости устаревших комплектующих, а
модернизация затруднена из-за проблемы несовместимости.
Существующий же в настоящее время порядок списания
компьютерной техники приводит к тому, что на балансе организации нередко «висит» значительное количество устаревшей, неисправной и неремонтопригодной техники.<br></br>
Частичным решением этой проблемы может стать своевременная <b>модернизация (upgrade) аппаратных средств</b>. Под ней
понимается увеличение производительности компьютера путем замены процессора, расширения оперативной памяти и
емкости жесткого диска тогда, когда это еще технически возможно, т. е. не позднее, чем через два года эксплуатации.

<h4 className="h3_main">Конфигурирование СВТ с учетом решаемых задач</h4>
Для формирования экономически эффективного парка СВТ
необходимо определять конфигурацию ПК, которая нужна
каждому отдельно взятому работнику.<br></br>
Условно можно определить <b>базовую конфигурацию</b> офисного настольного компьютера, которая обеспечивает выполнение минимального набора офисных функций и которая
будет являться основой при сборке более сложных специальных конфигураций путем простого улучшения количественных и скоростных показателей (установки большего объема
памяти, дополнительных накопителей, более мощного процессора и т. д.).<br></br>
Базовая конфигурация подойдет работникам, осуществляющим работу с текстами и электронными таблицами, занятым электронной и обычной перепиской. Компьютеры с
базовой конфигурацией подойдут как секретарю или менеджеру, так и аналитику, поэтому ориентироваться на тот или
иной отдел нет необходимости. В то же время если секретарь
может обойтись жестким диском минимального объема, то
аналитикам могут понадобиться дополнительные дисковые
массивы. Сократить расходы и повысить надежность хранения информации позволяют сетевые технологии и установка
дискового массива на сервере для хранения документов и
резервных копий информации со всех ПК, находящихся в
сети. Однако отказываться от накопителей на уровне пользовательских ПК и превращать их полностью в «тонкие
клиенты» нежелательно, так как обычные офисные приложения очень требовательны к количеству места на жестком
диске. В качестве минимального можно рекомендовать объем
жесткого диска 125 Гб. Для сервера же минимальный объем
жесткого диска составит 250 Гб.<br></br>

Важность правильного выбора компьютера обусловлена
следующими факторами:
<ul>
<li>номенклатура выпускаемых ПК очень велика;</li>
<li>характеристики компьютеров существенно отличаются
друг от друга;</li>
<li>стоимость компьютеров достаточно высока.</li>
</ul>
Основными характеристиками ПК являются:
<ul>
<li>надежность;</li>
<li>разрядность;</li>
<li>производительность (тактовая частота);</li>
<li>емкость основной памяти;</li>
<li>емкость жесткого диска;</li>
<li>вид операционной системы;</li>
<li>совместимость с другими компонентами СВТ;</li>
<li>режимы работы;</li>
<li>поддержка сети;</li>
<li>габариты.</li>
</ul>

Очень важно правильно подобрать конфигурацию компьютера. Например, тип основного <b>микропроцессора</b> и <b>материнской платы</b> должны совпадать.<br></br>
Далее, в зависимости от поставленных задач, нужно обратить внимание на объем и быстродействие <b>основной и внешней памяти</b> и на номенклатуру устройств внешней памяти.
Объем оперативной памяти в 4 Гб можно назвать более
чем достаточным для работы операционной системы и любых офисных приложений начального уровня. Если планируется использование графических и издательских пакетов,
то необходимо наращивание памяти до 8 Гб. Но превышение этой отметки для офисного ПК нецелесообразно.
Основной принцип при выборе объема памяти — «чем больше, тем комфортнее работать с развлекательными задачами». Но если один гигабайт оперативной памяти установить
в офисный ПК, то это никак не отразится на скорости набора текста или ввода значений в электронную таблицу.<br></br>
Для решения современных офисных задач достаточно
и мощности не самого быстрого <b>процессора</b>, выпускаемого несколько лет назад. Для офисных задач оптимальной можно
назвать частоту в 2100-3000 МГц. Однако ведущие производители (AMD и Intel), выпуская все более мощные модели,
снимают с производства более старые. Частоты новых процессоров начинаются сегодня с фактически ненужных двух
гигагерц. Более медленные же процессоры можно найти
лишь на рынке б/у комплектующих, что не отвечает требованиям повышенной надежности офисной техники.<br></br>
Покупка дополнительного <b>жесткого диска</b> позволит дублировать важную информацию. При поломке одного из жестких
дисков данные сохраняются на другом, и работать можно, не
дожидаясь замены вышедшего из строя жесткого диска.<br></br>
Далее надо определиться с типами системного и локального
интерфейсов, выбрать видеокарту, клавиатуру, мышь и монитор и определиться с общим дизайнерским решением. Для
обычной офисной работы достаточно интегрированной видеокарты; если же работа сотрудника связана с графикой, то
стоит позаботиться о более качественном видео.<br></br>


Что касается корпусов системных блоков, то личные вкусы работников чаще всего отодвигаются на задний план корпоративным стилем, но вот при выборе монитора принимать
во внимание трудовые функции и личные потребности каждого отдельного сотрудника надо строго обязательно: перед
монитором работник проводит огромное количество времени, и от качества экрана зависит его зрение и здоровье!<br></br>
Оптимальное рабочее разрешение 17-дюймового ЖК <b>монитора</b> для офисных задач — 1920 х 1080 точек. При этом
частота вертикальной развертки должна быть не менее
60 Гц. Каждый монитор необходимо проверить, протестировав его, например, при помощи утилиты Nokia Test, чтобы
выявить геометрические искажения и дефекты монитора.
Изображение должно быть четким, без цветовых и геометрических «завалов».
<br></br>
К компьютеру также желательно купить <b>источник бесперебойного питания</b> для защиты от скачков и отключения
электричества, от которых не застрахован и не поможет
даже самый высококачественный встроенный блок питания
компьютера. При этом имеет смысл обратить внимание на
ИБП, к которому можно подключить несколько устройств.<br></br>
Выбор <b>клавиатуры и манипулятора</b> — задача довольно
простая. Беспроводные клавиатуры и мыши — не для офиса: при использовании множества беспроводных устройств
могут появляться аппаратные конфликты. Причем у дешевых моделей такие конфликты неизбежны — сигналы будут
наводиться друг на друга и печатать текст на экране соседнего компьютера. Кроме того, сотрудники будут постоянно
путать мыши и терять их, поэтому клавиатура и мышь должны быть прочно «привязаны» к ПК кабелями.<br></br>
Выбирать лучше простые и недорогие устройства. Желательно, чтобы мышь и клавиатура были если не белыми, то
светлых тонов, что облегчит контроль за их гигиеническим
состоянием. В настоящее время лучше использовать проводную оптическую мышь. Достоинство «оптики» — не только
в плавном и точном движении курсора по экрану, но и в
отсутствии необходимости чистить шарик и коврик, — ведь
оптическая мышь может двигаться практически по любой
поверхности.<br></br>
При выборе <b>оптического накопителя</b> нужно учитывать
потребности работника. Если специфика его деятельности
такова, что необходима частая или постоянная запись информации на носители или чтение с них, то экономить здесь
нельзя: это может привести к падению производительности,
что тут же «съест» любую экономию. Сегодня скорость накопителей на запись начинается с 16х — ее достаточно, чтобы 700 Мб записать быстрее, чем за 8 минут. Для записи
следует выбирать и качественные носители. В то же время
пока нельзя отказываться и от 3,5-дюймовых дискет, с которыми еще несколько лет придется сталкиваться и работать.<br></br>
При необходимости можно дополнить ПК различными
<b>периферийными устройствами</b> (принтером, сканером и т. д.).
В частности, сканер для работы с текстами подойдет самый
дешевый и даже с самыми посредственными характеристиками. Единственное, на что нужно обратить внимание, —
это наличие интерфейса USB 3.0, который является определяющим фактором скорости передачи данных со сканера на
компьютер.<br></br>
Для офиса необходимо обеспечить возможности печати корпоративного уровня — высокоскоростной принтер, включенный в сеть и способный обслуживать всех работников. Однако
такие решения достаточно дороги, а потому более целесообразным представляется приобретение <b>многофункциональных
устройств (МФУ)</b>, сочетающих в себе функции принтера,
сканера, копира и факса. Благодаря такой функциональности
в одном корпусе можно сэкономить место на рабочих столах,
а заодно сэкономить затраты на отдельные копир, сканер и
факс. Несколько таких МФУ вполне смогут заменить корпоративное печатающее устройство и сэкономить денежные средства. При выборе МФУ необходимо ориентироваться на наиболее технологически продвинутые решения и прежде всего —
на объемы расхода тонера. Многофункциональные устройства
должны быть максимально экономными. «Продвинутые» модели стоят зачастую в два раза дороже моделей, кажущихся
аналогичными, но у дешевых печатающих устройств — дорогие картриджи и значительно больше расход тонера. Поэтому,
приобретая дорогое устройство, пользователь в итоге очень
часто получает экономию на стоимости одной копии.

<h4 className="h3_main">Модернизация СВТ с учетом решаемых задач</h4>

Даже самый недорогой компьютер должен иметь возможности
для модернизации. При отсутствии же таковой в случае роста
объемов задач придется не просто модернизировать и повышать мощность СВТ, а полностью менять парк компьютеров.
В результате экономия обернется двойными расходами.<br></br>

Модернизация компьютера может быть обусловлена следующими причинами:
<ul>
<li>расширение или изменение круга решаемых задач, т. е.
изменение типа ПК;</li>
<li>выход из строя комплектующих;</li>
<li>замена комплектующих на более производительные.</li>
</ul>
Выбор комплектующих зависит от типа персонального
компьютера и от финансовых возможностей и потребностей
покупателя.<br></br>
Напрямую производительность компьютера не зависит
от одной только мощности процессора — в вычислительной
системе все должно быть сбалансировано. Если поставить
мощный процессор на слабую материнскую плату, то и он
будет работать «вполсилы».<br></br>
Условно все компьютеры можно разделить на две группы:
<ul>
<li><b>«brand name»</b> — собранные фирмами-производителями
основных блоков компьютера (IBM, Compaq, HP);</li>
<li><b>«no name»</b> — компьютеры, сборку которых осуществляли из комплектующих сторонние производители.</li>
</ul>
Компьютеры первой группы — более дорогие, но и более
надежные, чем компьютеры второй группы.<br></br>
Вместо формирования парка СВТ на базе настольных ПК
<b>(десктопов)</b> можно рассмотреть другой вариант — приобретение ноутбуков.<br></br>
Ноутбуки занимают мало места, потребляют мало энергии и, самое главное, сегодня они доступны по цене: современные высокопроизводительные ноутбуки уже имеют стоимость от 30 000 рублей при практически тех же характеристиках, что и десктопы. Ноутбуки — легкие, компактные,
их мощности достаточно для выполнения любых офисных и
развлекательных задач. Однако при широком использовании в офисе ноутбуков необходимы дополнительные меры
безопасности, которые касаются сохранности как информации, так и самих ноутбуков. Переносные компьютеры являются привлекательными объектами для краж, а сотрудники
могут легко стать жертвой грабежа и мошенничества. К со­жалению, ни одна из российских страховых компаний ноутбуки не страхует, поэтому если доступ в офис открыт, то необходимо оборудовать рабочие места гнездами («слотами»)
для <b>замков Кенсингтона</b> и обязать сотрудников держать
ноутбуки «на привязи» в течение всего рабочего дня.<br></br>
Резервная копия рабочих данных с жесткого диска каждого корпоративного ноутбука должна сохраняться на сервере компании и при каждом соединении синхронизироваться. Кроме того, требуются дополнительные программные
средства для защиты и шифрования информации: в случае
кражи ноутбука похититель не должен иметь возможность
получить доступ к содержимому его жесткого диска.<br></br>
Ноутбук у сотрудника компании производит положительное впечатление на клиентов и партнеров. Сам же сотрудник получает в свое распоряжение функциональность мобильного офиса. На деловой встрече все документы всегда
будут под рукой. Ноутбук можно использовать для презентаций. Если захватить с собой переносной принтер, то ваш
клиент тут же получит деловое предложение на бумаге.
Проект договора или любой другой необходимый документ
можно и записать потенциальному клиенту на дискету, оптический диск, карту памяти или флэш-накопитель или
даже отправить по e-mail, выйдя в сеть Интернет по каналу
GPRS или Wi-Fi.<br></br>
Еще одно достоинство — в случае отключения электричества сотрудники смогут работать на компьютере не 5-10 минут,
как с использованием ИБП, а около 2-2,5 часов на встроенных аккумуляторных батареях. Средства же беспроводной
связи Wi-Fi избавят ваш офис от проводов и облегчат коммуникацию между сотрудниками.<br></br>

До покупки ноутбука необходимо узнать, насколько оперативно производится его ремонт различной сложности.
Если запасные части поставляются только «под заказ», то любая, даже самая несерьезная поломка может обернуться
серьезным простоем. Это — самая главная проблема при
формировании парка ноутбуков. Если же ремонт производится оперативно, то компании достаточно иметь резервный
десктоп или дополнительный ноутбук, на котором работник
сможет работать во время ремонта своего компьютера.<br></br>

Для объединения компьютеров в сеть с точки зрения модернизации лучше использовать <b>технологию «тонкий клиент» (терминал)</b>, когда все базы данных хранятся на сервере, а к большинству программ, установленных на сервере,
имеется общий доступ. При другой сетевой технологии со
временем каждый ПК необходимо модернизировать отдельно, что увеличивает затраты. Кроме того, появляется проблема утилизации устаревших элементов ПК.<br></br>
Модернизация терминалов (клиентского парка) при таком подходе не требуется: при росте требований со стороны
прикладного ПО наращивается мощность только терминального сервера (или их количество — при приложениях с балансировкой нагрузки), что значительно дешевле, чем модернизация всего парка ПК. Более того, терминальная технология позволит использовать даже устаревший парк ПК
с новым программным обеспечением.<br></br>
Таким образом, как и двадцать лет назад, технология «тонкий клиент» остается наиболее оптимальным решением для
построения компьютерных сетей крупных предприятий, обеспечивая необходимый уровень технологичности, безопасности информации и организации производственного процесса.



                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default lecture_2_4